<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'بيانات المعلمين'" :to="{name: 'students'}">بيانات الطلاب المقبولين </router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'students.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                           <i class="flaticon-computer-4"></i>
                                          بيانات طالب</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                              <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li class="nav-item">
                                  <a class="nav-link active" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="true"><i class="fa-regular fa-user text-primary"></i> البيانات الشخصية</a>
                                </li>
                                 <li class="nav-item">
                                  <a class="nav-link" id="ident-tab" data-toggle="tab" href="#ident" role="tab" aria-controls="ident" aria-selected="false"><i class="fa-regular fa-address-book text-primary"></i> معلومات الهوية</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false"><i class="fa-regular fa-address-card text-primary"></i> معلومات التواصل</a>
                                </li>

                                <li class="nav-item">
                                  <a class="nav-link" id="work-tab" data-toggle="tab" href="#work" role="tab" aria-controls="work" aria-selected="false"><i class="fa-regular fa-note-sticky text-primary"></i> معلومات العمل</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="exp-tab" data-toggle="tab" href="#exp" role="tab" aria-controls="exp" aria-selected="false"><i class="fa-regular fa-note-sticky text-primary"></i> معلومات ولى الامر</a>
                                </li>
                                <li class="nav-item">
                                  <a class="nav-link" id="imgs-tab" data-toggle="tab" href="#imgs" role="tab" aria-controls="imgs" aria-selected="false"><i class="fa-regular fa-note-sticky text-primary"></i> صورة الهوية</a>
                                </li>
                              </ul>
                              <form @submit.prevent="store()">
                                <div class="tab-content" id="myTabContent">
                                  <div class="tab-pane fade show active" id="personal" role="tabpanel" aria-labelledby="personal-tab">
                                    <div class="row mt-4">
                                         <div class="col-md-4">
                                              <label for="exampleFormControlInput12">الاسم <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                            <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.name" placeholder="الاسم كامل">
                                            <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                                                  {{ getErrors['name'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                       <div class="col-md-4">
                                               <label for="exampleFormControlInput12">تاريخ الميلاد</label>
                                  <div class="input-group mb-4">

                                            <date-picker v-model="data.form.birth_date" @change="getAge()" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['birth_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['birth_date']">
                                                  {{ getErrors['birth_date'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <label for="exampleFormControlInput12">مكان الميلاد</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.birth_place" placeholder="مكان الميلاد">
                                            <div class="invalid-feedback" :style="getErrors['birth_place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['birth_place']">
                                                  {{ getErrors['birth_place'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <label for="exampleFormControlInput12">تاريخ التسجيل <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                            <date-picker v-model="data.form.register_date" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['register_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['register_date']">
                                                  {{ getErrors['register_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المرحلة الدراسية <span class="text-danger">*</span></label>
                                            <treeselect :options="stages" v-model="data.form.stage_id" @select="getGroups" :multiple="false" />
                                            <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                                                  {{ getErrors['stage_id'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الصف الدراسى <span class="text-danger">*</span></label>
                                           
                                            <treeselect :options="groups" v-model="data.form.group_id" @select="getLessons" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                                                  {{ getErrors['group_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> الحلقة <span class="text-danger">*</span></label>
                                            <treeselect :options="lessons" v-model="data.form.lesson_id" @select="getSuper($event); getTeachers($event)" :multiple="false" />

                                            <div class="invalid-feedback" :style="getErrors['lesson_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['lesson_id']">
                                                  {{ getErrors['lesson_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> اسم المعلم   <span class="text-danger">*</span></label>
                                            <v-select v-model="teacher" @option:selected="setInputTeacher" :options="teachers" @search="onSearchTeacher" />
                                            <div class="invalid-feedback" :style="getErrors['teacher_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['teacher_id']">
                                                  {{ getErrors['teacher_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">اسم المشرف التربوى    </label>
                                            <v-select v-model="supervisor" @option:selected="setInputSuper" :options="supervisors" @search="onSearchSupervisor" />
                                            <div class="invalid-feedback" :style="getErrors['supervisor_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['supervisor_id']">
                                                  {{ getErrors['supervisor_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">الحالة الاجتماعية</label>
                                            <div class="row">
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="طالب"> طالب</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="أعزب"> أعزب</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="متزوج"> متزوج</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.marital_status" value="أرمل"> أرمل</div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['marital_status'] ? 'display: block' : 'display: none;'"  v-if="getErrors['marital_status']">
                                                  {{ getErrors['marital_status'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> حالة الطالب</label>
                                            <div class="row">
                                              <div class="col-md-3"><input type="radio" v-model="data.form.student_status" value="جديد"> جديد</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.student_status" value="مستمر"> مستمر</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.student_status" value="منفصل"> منفصل</div>
                                              <div class="col-md-3"><input type="radio" v-model="data.form.student_status" value="متوقف"> متوقف</div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['student_status'] ? 'display: block' : 'display: none;'"  v-if="getErrors['student_status']">
                                                  {{ getErrors['student_status'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                    </div>
                                  <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                     <div class="row mt-4">
                                      <div class="col-md-6">

                                        <label for="exampleFormControlInput12">عنوان المنزل</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.address" placeholder="اكتب العنوان">
                                            <div class="invalid-feedback" :style="getErrors['address'] ? 'display: block' : 'display: none;'"  v-if="getErrors['address']">
                                                  {{ getErrors['address'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">

                                    <label for="exampleFormControlInput12">رقم الهاتف 1</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.phone1" placeholder="رقم الهاتف 1">
                                            <div class="invalid-feedback" :style="getErrors['phone1'] ? 'display: block' : 'display: none;'"  v-if="getErrors['phone1']">
                                                  {{ getErrors['phone1'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                   <div class="col-md-6">

                                     <label for="exampleFormControlInput12">رقم الهاتف 2</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.phone2" placeholder="رقم الهاتف 2">
                                            <div class="invalid-feedback" :style="getErrors['phone2'] ? 'display: block' : 'display: none;'"  v-if="getErrors['phone2']">
                                                  {{ getErrors['phone2'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                      <label for="exampleFormControlInput12">رقم الجوال</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.mobile" placeholder="رقم الجوال">
                                            <div class="invalid-feedback" :style="getErrors['mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['mobile']">
                                                  {{ getErrors['mobile'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                   <label for="exampleFormControlInput12">رقم واتس آب</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.whatsapp" placeholder="رقم واتس آب">
                                            <div class="invalid-feedback" :style="getErrors['whatsapp'] ? 'display: block' : 'display: none;'"  v-if="getErrors['whatsapp']">
                                                  {{ getErrors['whatsapp'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                         <label for="exampleFormControlInput12"> البريد الإلكتروني </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-email"></i></span>
                                      </div>


                                            <input type="email" class="form-control" v-model="data.form.email" placeholder="البريد الإلكتروني">
                                            <div class="invalid-feedback" :style="getErrors['email'] ? 'display: block' : 'display: none;'"  v-if="getErrors['email']">
                                                  {{ getErrors['email'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>

                                  </div>
                                  <div class="tab-pane fade" id="ident" role="tabpanel" aria-labelledby="ident-tab">
                                    <div class="row mt-4">
                                       <div class="col-md-6">
                                         <label for="exampleFormControlInput12">رقم الهوية <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.id_number" placeholder="رقم الهوية">
                                            <div class="invalid-feedback" :style="getErrors['id_number'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_number']">
                                                  {{ getErrors['id_number'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                              <label for="exampleFormControlInput12">مصدرها</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.id_place" placeholder="مصدر الهوية">
                                            <div class="invalid-feedback" :style="getErrors['id_place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_place']">
                                                  {{ getErrors['id_place'][0] }}
                                            </div>
                                        </div>
                                      </div>


                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخها</label>
                                            <date-picker v-model="data.form.id_date" @change="validateExpire();"  :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['id_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_date']">
                                                  {{ getErrors['id_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">تاريخ الانتهاء</label>
                                            <date-picker v-model="data.form.id_expire_date" @change="validateExpire();validateIdDate();" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['id_expire_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_expire_date']">
                                                  {{ getErrors['id_expire_date'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                       <div class="col-md-12">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> نوع الهوية <span class="text-danger">*</span></label>
                                            <div class="row">
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="رقم الاقامة"> <label for="">رقم الاقامة</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="رقم البرنت للمرفقين" > <label for="">رقم البرنت للمرفقين</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="بطاقة أحوال"> <label for="">بطاقة أحوال</label>
                                              </div>
                                              <div class="col-md-3">
                                                <input type="radio" v-model="data.form.id_type" value="كرت عائلة"> <label for="">كرت عائلة</label>
                                              </div>
                                            </div>
                                            <div class="invalid-feedback" :style="getErrors['id_type'] ? 'display: block' : 'display: none;'"  v-if="getErrors['id_type']">
                                                  {{ getErrors['id_type'][0] }}
                                            </div>
                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="work" role="tabpanel" aria-labelledby="work-tab">
                                    <div class="row mt-4">
                                   <div class="col-md-4">
                                         <label for="exampleFormControlInput12">العمل </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.work" placeholder="العمل الرسمى">
                                            <div class="invalid-feedback" :style="getErrors['work'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work']">
                                                  {{ getErrors['work'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                                                        <div class="col-md-4">
                                        <label for="exampleFormControlInput12">العنوان</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.work_address" placeholder="اكتب عنوان العمل">
                                            <div class="invalid-feedback" :style="getErrors['work_address'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_address']">
                                                  {{ getErrors['work_address'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                                                         <div class="col-md-4">
                                      <label for="exampleFormControlInput12">الهاتف</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.work_phone" placeholder="الهاتف">
                                            <div class="invalid-feedback" :style="getErrors['work_phone'] ? 'display: block' : 'display: none;'"  v-if="getErrors['work_phone']">
                                                  {{ getErrors['work_phone'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                  <div class="tab-pane fade" id="exp" role="tabpanel" aria-labelledby="exp-tab">
                                    <div class="row mt-4">

                             <div class="col-md-6">

                                     <label for="exampleFormControlInput12">اسم ولى الامر <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.parent_name" placeholder="اسم ولى الامر">
                                            <div class="invalid-feedback" :style="getErrors['parent_name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_name']">
                                                  {{ getErrors['parent_name'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                                                <label for="exampleFormControlInput12">عمل ولى الامر </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.parent_work" placeholder="عمل ولى الامر">
                                            <div class="invalid-feedback" :style="getErrors['parent_work'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_work']">
                                                  {{ getErrors['parent_work'][0] }}
                                            </div>
                                        </div>
                                      </div>
                             <div class="col-md-6">
                                      <label for="exampleFormControlInput12">هاتف عمله </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.parent_work_phone" placeholder="هاتف عمله">
                                            <div class="invalid-feedback" :style="getErrors['parent_work_phone'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_work_phone']">
                                                  {{ getErrors['parent_work_phone'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                                          <div class="col-md-6">
                                     <label for="exampleFormControlInput12">جواله <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.parent_mobile" placeholder="جواله">
                                            <div class="invalid-feedback" :style="getErrors['parent_mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_mobile']">
                                                  {{ getErrors['parent_mobile'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                                            <div class="col-md-12">
                      <label for="exampleFormControlInput12">صلة القرابة <span class="text-danger">*</span></label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.parent_relation" placeholder="صلة القرابة">
                                            <div class="invalid-feedback" :style="getErrors['parent_relation'] ? 'display: block' : 'display: none;'"  v-if="getErrors['parent_relation']">
                                                  {{ getErrors['parent_relation'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                  <div class="tab-pane fade" id="imgs" role="tabpanel" aria-labelledby="imgs-tab">
                                    <div class="row mt-4">

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> صورة الهوية <span class="text-danger">*</span></label>
                                           <input type="file" ref="file" class="form-control" accept="image/*"  @change="uploadImage">
                                            <div class="invalid-feedback" :style="getErrors['image_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['image_id']">
                                                  {{ getErrors['image_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-6">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12"> صورة شخصية </label>
                                           <input type="file" ref="file1" class="form-control" accept="image/*"  @change="uploadImageProfile">
                                            <div class="invalid-feedback" :style="getErrors['image'] ? 'display: block' : 'display: none;'"  v-if="getErrors['image']">
                                                  {{ getErrors['image'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'students'}">
                                      <span>رجوع</span>
                                    </router-link>

                                   </form>

                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueDatetimeJs from 'vue-datetime-js'
export default {
  components: {
    datePicker: VueDatetimeJs,
    Treeselect
  },
  data() {
    return {
      datesDisabled: {
        expire: {
          from: ''
        }
      },
      date: '',
      data: {
        checker: false,
        form:{
            name: '',
            birth_date: '',
            birth_place: '',
            student_status: '',
            marital_status: '',
            lesson_id: '',
            group_id: '',
            teacher_id: '',
            stage_id: '',
            supervisor_id: '',
            interview_id: '',
            address: '',
            register_date: '',
            whatsapp: '',
            mobile: '',
            phone1: '',
            phone2: '',
            email: '',
            id_number: '',
            id_place: '',
            id_type: '',
            id_date: '',
            id_expire_date: '',
            work: '',
            work_address: '',
            work_phone: '',
            parent_name: '',
            parent_work: '',
            parent_work_phone: '',
            parent_mobile: '',
            parent_relation: '',
            image_id: '',
            image: '',
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {},
      },
      stages: [],
       stage: '',
       groups: [],
       group: '',
       lessons: [],
       lesson: '',
       supervisors: [],
       supervisor: '',
       teachers: [],
       teacher: '',
    };
  },
  created(){
    let interview = this.$route.query.interview;
    if(interview){
      this.transInterviewData(interview);
    }
    this.getRequirements();
  },
  methods: {
    resetForm(){
      let interview = this.$route.query.interview;
        if(interview){
          this.transInterviewData(interview);
        }else{
          this.data.form = {
             name: '',
            birth_date: '',
            birth_place: '',
            student_status: '',
            marital_status: '',
            lesson_id: '',
            group_id: '',
            teacher_id: '',
            stage_id: '',
            supervisor_id: '',
            interview_id: '',
            address: '',
            register_date: '',
            whatsapp: '',
            mobile: '',
            phone1: '',
            phone2: '',
            email: '',
            id_number: '',
            id_place: '',
            id_type: '',
            id_date: '',
            id_expire_date: '',
            work: '',
            work_address: '',
            work_phone: '',
            parent_name: '',
            parent_work: '',
            parent_work_phone: '',
            parent_mobile: '',
            parent_relation: '',
            image_id: '',
            image: '',
        };
        }

    },
    getAge(){
        let year = new Intl.DateTimeFormat('ar-FR-u-ca-islamic', {year : 'numeric'}).format(Date.now());
        year = year.replace(/ هـ/g,'');
        let strArray = this.data.form.birth_date.split("/");
        let birth    = strArray[0];
        let age = Number(year) - Number(birth);
        if(age < 4){
          this.data.form.birth_date = '';
          this.sweetAlert('العمر لابد ان يكون اكبر او يساوى 4 سنوات', 'error');
        }
      },
      validateExpire(){
        if(this.data.form.id_expire_date == '' || this.data.form.id_date == ''){
          return;
        }
        if(this.data.form.id_expire_date < this.data.form.id_date){
          this.sweetAlert('تاريخ الانتهاء  لابد ان يكون اكبر من تاريخ اصدار الهوية', 'error');
          this.data.form.id_expire_date = '';
        }
        if(this.datesDisabled.expire.from > this.data.form.id_expire_date){
           this.sweetAlert('تاريخ انتهاء الهوية غير صالح', 'error');
           this.data.form.id_expire_date = '';
        }
      },
      validateIdDate(){
        if(this.data.form.id_date == ''){
          return;
        }
        if(this.datesDisabled.expire.from < this.data.form.id_date){
           this.sweetAlert('تاريخ الهوية غير صالح', 'error');
           this.data.form.id_date = '';
        }
      },
    setInputStage(op){
      this.data.form.stage_id = op.id;
    },
    setInputGroup(op){
      this.data.form.group_id = op.id;
    },
     setInputLesson(op){
      this.data.form.lesson_id = op.id;
    },
    setInputTeacher(op){
      this.data.form.teacher_id = op.id;
    },
    setInputSuper(op){
      this.data.form.supervisor_id = op.id;
    },

    onSearchGroup(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'groups');
      }
    },

    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stages');
      }
    },

    onSearchLesson(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'lessons');
      }
    },
    onSearchTeacher(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'teachers');
      }
    },

    onSearchSupervisor(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'supervisors');
      }
    },

    transInterviewData(interview){
      this.$baseApi.get('/students/create?interview='+interview).then((response)=>{

            if(response.data.code == 200){
              let data = response.data.data.interview;
              if(data){
              this.data.form.name = data.name;
              this.data.form.group_id = data.group_id;
              this.data.form.stage_id = data.stage_id;
              this.data.form.birth_date = data.birth_date;
              this.data.form.phone1 = data.phone;
              this.data.form.register_date = data.interview_date;
              this.data.form.student_status = 'جديد';
              this.data.form.mobile = data.mobile;
              this.data.form.parent_mobile = data.parent_mobile;
              this.data.form.interview_id = data.id;
              this.data.form.parent_id = data.parent_id;
              this.data.form.parent_name = data.parent ? data.parent.name : '';
      


              }
              this.datesDisabled.expire.from = response.data.data.expireDate;
              this.stages = response.data.data.stages;
              this.groups = response.data.data.groups;
              this.lessons = response.data.data.lessons;


            }else{
                alert(response.data.error.error);
            }
        });
    },

    search(loading, w, vm, mod){
      this.$baseApi.get('/students/create?pluck=1&search='+w+'&mod='+mod).then((response)=>{
          if(loading){
              loading(false);
          }
            if(response.data.code == 200){
              let options = response.data.data.options;
              if(mod == 'stages'){
                this.stages = options;
              }else if(mod == 'groups'){
                this.groups = options;
              }else if(mod == 'teachers'){
                this.teachers = options;
              }else if(mod == 'supervisors'){
                this.supervisors = options;
              }else{
                this.lessons = options;
              }

            }else{
                alert(response.data.error.error);
            }
        });
    },

     uploadImage(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.image_id = e.target.result;
                };
      },

      uploadImageProfile(e){
                const image = e.target.files[0];
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                  this.data.form.image = e.target.result;
                };
      },

      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/students', this.data.form).then((response)=>{
            if(response.data.code === 200){
          localStorage.setItem('flash_message', 'تمت عملية الاضافة');
                router.push('/students');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
        // // this.getRoles();
        // this.search(null, '', this, 'groups');
        // this.search(null, '', this, 'stages');
        // this.search(null, '', this, 'lessons');
        // this.search(null, '', this, 'teachers');
        // this.search(null, '', this, 'supervisors');

      },
      getGroups(val){
         this.$baseApi.get('/students/create?option=group&i='+val.id).then((response)=>{
            if(response.data.code == 200){
              this.data.form.group_id = '';
              this.data.form.lesson_id = '';
               this.groups = response.data.data.groups;
               this.lessons = response.data.data.lessons;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getTeachers(val){
         this.$baseApi.get('/students/create?pluck=1&mod=teachers&i='+val.id).then((response)=>{
            if(response.data.code == 200){
              this.data.form.supervisor_id = '';
              this.data.form.teacher_id = '';
               this.teachers = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getSuper(val){
         this.$baseApi.get('/students/create?pluck=1&mod=supervisors&i='+val.id).then((response)=>{
            if(response.data.code == 200){
              this.data.form.supervisor_id = '';
               this.supervisors = response.data.data.options;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getLessons(val){
         this.$baseApi.get('/students/' + this.$route.params.id + '/edit?pluck=1&i='+val.id).then((response)=>{
            if(response.data.code == 200){
              this.data.form.teacher_id = '';
              this.data.form.supervisor_id = '';
              this.data.form.lesson_id = '';
              this.lessons = response.data.data.options;
              this.teachers = [];
              this.supervisors = [];
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getRoles(){
        this.$baseApi.get('/students/create').then((response)=>{
            if(response.data.code == 200){
               this.data.roles = response.data.data.roles;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.data.form.location_id = node.id;
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  }
};
</script>
<style>
</style>
